// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialLinkedinComponent} from './SocialLinkedin.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialLinkedin = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialLinkedinComponent/>
  </Icon>
));
